import { api } from "@/features/utils/fetch-server";
import type { MetadataConfig, MetadataField } from "../types";

export class MetadataConfigAPI {
  // Get metadata configuration
  static getConfig = async (clientId: string): Promise<MetadataConfig> =>
    api.get(`/api/rag/v1/${clientId}/metadata-config`);

  // Update metadata configuration
  static updateConfig = async (
    clientId: string,
    fields: MetadataField[],
  ): Promise<MetadataConfig> =>
    api.put(`/api/rag/v1/${clientId}/metadata-config`, { fields });
}
